export const locationTypes = {
  facility: "Facility",
  organization: "Organization"
};
